export default __webpack_public_path__ + "static/media/med2lab_logo.da612404.png";